import React, { useEffect } from 'react'
import styles from './styles.module.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import { deleteManners, getMannersList, } from '../../../../actions/directoryBasicEducation'


export default function Complaint({diagnosisComplaintList, setDiagnosisComplaint, closeComplain}) {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getMannersList())
  }, [])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }
  const selected = (data) => () => {
    setDiagnosisComplaint(data)
    closeComplain()
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteManners(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { id, name } = data
    return (
      <tr >
        <td onClick={selected(data)}>{name}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: id, name: name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={!selectedItem.name}
        />
      }
      <h1>Диагноз при поступлении(жалоба)</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Название</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {diagnosisComplaintList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
     
      </div>
    </div>
  )
}
